const FileTransferProgressStateEnum = {};

FileTransferProgressStateEnum.PREPARED = 0;
FileTransferProgressStateEnum.DOWNLOADING = 1;
FileTransferProgressStateEnum.UPLOADING = 2;
FileTransferProgressStateEnum.FINISHED = 3;
FileTransferProgressStateEnum.FAILED = 4;
FileTransferProgressStateEnum.INSTRUMENT_DISCONNECTED = 5;
FileTransferProgressStateEnum.CONNECTION_TIMEOUT = 6;

FileTransferProgressStateEnum.GetDescriptionString = (enumValue) => {
  switch (enumValue) {
    case FileTransferProgressStateEnum.PREPARED:
      return 'Prepared for transfer';
    case FileTransferProgressStateEnum.DOWNLOADING:
      return 'Transfer to instrument';
    case FileTransferProgressStateEnum.UPLOADING:
      return 'Transfer from instrument';
    case FileTransferProgressStateEnum.FINISHED:
      return 'Finished';
    case FileTransferProgressStateEnum.FAILED:
      return 'Failed';
    case FileTransferProgressStateEnum.INSTRUMENT_DISCONNECTED:
      return 'Instrument disconnected';
    case FileTransferProgressStateEnum.CONNECTION_TIMEOUT:
      return 'Connection timeout';
    default:
      return 'Unknown';
  }
};

export default FileTransferProgressStateEnum;
